import { SearchField } from "./SearchField";
import { FiltersPanel } from "./FiltersPanel";
import { SpotList } from "./SpotList";
import { useLang } from "../i18n/LangContext";

interface SidebarProps {
  /** True when the viewport is in the mobile breakpoint — in that case
   *  search, filter and spot list live in floating bottom-sheets
   *  rendered by MapPage, not inline in the sidebar. */
  mobile?: boolean;
}

export function Sidebar({ mobile }: SidebarProps) {
  const { t } = useLang();
  if (mobile) return null;
  return (
    <aside id="sidebar">
      <div className="sidebar-sticky">
        <SearchField />
      </div>
      <FiltersPanel />
      <SpotList />
      <footer className="sidebar-credit">
        <p className="muted credit">{t("creditFooter")}</p>
      </footer>
    </aside>
  );
}
